import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { V_URL } from "../../../../../BaseUrl";
import Swal from "sweetalert2";
import axios from "axios";
import toast from "react-hot-toast";
import Header from "../../../Include/Header";
import Sidebar from "../../../Include/Sidebar";
import Footer from "../../../Include/Footer";
import { Pagination } from "../../../Table";
import Loader from "../../../Include/Loader";
import moment from "moment";
import { getDeliveryChallan } from "../../../../../Store/prosafe/proTransaction/Challan/getDeliveryChallan";
import { getAdminItem } from "../../../../../Store/Store/Item/AdminItem";
import { getProject } from "../../../../../Store/Store/Project/Project";
import { getCategory } from "../../../../../Store/Store/StoreMaster/Category/Category";
import PageHeader from "../../../Components/PageHeader/PageHeader";
import useDebounce from "../../../../../hooks/useDebounce";

const DeliveryChallanList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [limit, setlimit] = useState(10);

  const [filter, setFilter] = useState({
    startDate: null,
    endDate: null,
    item: null,
    category: null,
    project: null,
    challan_type: null,
  });

  const debouncedSearch = useDebounce(search, 500);

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1);
  };

  useEffect(() => {
    dispatch(getAdminItem({ is_main: true }));
    dispatch(getProject());
    dispatch(getCategory());
  }, []);

  const fetchData = () => {
    const payload = {
      search: search,
      page: currentPage,
      limit: limit,
      start_date: filter.startDate,
      end_date: filter.endDate,
      item_id: filter.item,
      item_category_id: filter.category,
      project_id: filter.project,
      challan_type: filter.challan_type,
      firm_id: localStorage.getItem("PAY_USER_FIRM_ID"),
      year_id: localStorage.getItem("PAY_USER_YEAR_ID"),
    };
    dispatch(getDeliveryChallan({ formData: payload }));
  }

  useEffect(() => {
    fetchData();
  }, [currentPage, limit, debouncedSearch, filter]);

  const entity = useSelector((state) => state?.getDeliveryChallan?.user?.data);
  const isLoading = useSelector((state) => state?.getDeliveryChallan?.loading);
  const itemData = useSelector((state) => state?.getAdminItem?.user?.data);
  const projectData = useSelector((state) => state?.getProject?.user?.data);
  const categoryData = useSelector((state) => state?.getCategory?.user?.data);

  const challanData = entity?.data || [];
  const pagination = entity?.pagination;

  useEffect(() => {
    if (pagination?.total) {
      setTotalItems(pagination?.total);
    }
  }, [pagination]);

  const handleRefresh = () => {
    // fetchData();
    setCurrentPage(1);
    setFilter({
      startDate: null,
      endDate: null,
      item: null,
      category: null,
      project: null,
      challan_type: null,
    });
  };

  const filterConfig = [
    // {
    //   key: "item",
    //   label: "Item",
    //   type: "dropdown",
    //   value: filter.item,
    //   placeholder: "Select Item",
    //   searchable: true,
    //   options:
    //     itemData?.map((item) => ({ label: item.name, value: item._id })) || [],
    // },
    // {
    //   key: "category",
    //   label: "Item Category",
    //   type: "dropdown",
    //   value: filter.category,
    //   placeholder: "Select Item Category",
    //   searchable: true,
    //   options:
    //     categoryData?.map((category) => ({
    //       label: category.name,
    //       value: category._id,
    //     })) || [],
    // },
    {
      key: "project",
      label: "Project",
      type: "dropdown",
      value: filter.project,
      placeholder: "Select Project",
      searchable: true,
      options:
        projectData?.map((project) => ({
          label: `${project.name} (${project.project_no})`,
          value: project._id,
        })) || [],
    },
    {
      key: "challan_type",
      label: "Challan Type",
      type: "dropdown",
      value: filter.challan_type,
      placeholder: "Select Type",
      options: [
        { label: "Returnable", value: "Returnable" },
        { label: "Non-Returnable", value: "Non-Returnable" },
      ],
    },
    {
      key: "startDate",
      label: "Start Date",
      type: "date",
      value: filter.startDate,
      placeholder: "Select Start Date",
    },
    {
      key: "endDate",
      label: "End Date",
      type: "date",
      value: filter.endDate,
      placeholder: "Select End Date",
    },
  ];

  const handleDownloadChallan = async (id) => {
    try {
      const myurl = `${V_URL}/prosafe/download-delivery-challan/${id}`;
      axios({
        method: "get",
        url: myurl,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
        },
      })
        .then((response) => {
          if (response.data.success === true) {
            toast.success(response?.data?.message);
            window.open(response?.data?.data?.pdfUrl, "_blank");
            fetchData();
          } else {
            toast.error(response?.data?.message);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || "Something went wrong");
        });
    } catch (err) {
      console.log(err);
    }
  };

  const handleDelete = (id, title) => {
    Swal.fire({
      title: `Are you sure want to delete ${title}?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const myurl = `${V_URL}/prosafe/delete-delivery-challan/${id}`;
        axios({
          method: "delete",
          url: myurl,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
          },
        })
          .then((response) => {
            if (response.data.success === true) {
              toast.success(response?.data?.message);
              fetchData();
            } else {
              toast.error(response?.data?.message);
            }
          })
          .catch((error) => {
            toast.error(
              error?.response?.data?.message || "Something went wrong",
            );
          });
      }
    });
  };

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    setCurrentPage(1);
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const breadCrumbs = [
    { label: "Dashboard", link: "/main-store/user/dashboard" },
    { label: "Delivery Challan" },
  ];

  const handleDownloadExcel = async () => {
    try {
      const payload = {
        search,
        start_date: filter.startDate,
        end_date: filter.endDate,
        item_id: filter.item,
        item_category_id: filter.category,
        project_id: filter.project,
        firm_id: localStorage.getItem("PAY_USER_FIRM_ID"),
        year_id: localStorage.getItem("PAY_USER_YEAR_ID"),
      };

      const res = await axios.post(
        `${V_URL}/prosafe/xlsx-delivery-challan`,
        payload,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
          },
        }
      );

      if (res?.data) {
        window.open(res?.data?.data?.url);
        toast.success(res?.data?.message || "Excel downloaded successfully");
      } else {
        toast.error("Failed to download");
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message || "Download failed");
    }
  };

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <div className="card-body">

                  <PageHeader
                    title="Delivery Challan"
                    breadcrumbs={breadCrumbs}
                    onSearch={handleSearch}
                    addButtonLink="/main-store/user/manage-delivery-challan"
                    onRefresh={handleRefresh}
                    filter={filter}
                    onFilterChange={handleFilterChange}
                    limit={limit}
                    onLimitChange={(val) => setlimit(val)}
                    filterConfig={filterConfig}
                    onDownload={handleDownloadExcel}
                  />

                  {!isLoading ? (
                    <div className="table-responsive">
                      <table className="table border-0 custom-table comman-table  mb-0">
                        <thead>
                          <tr>
                            <th>Sr.</th>
                            <th>Date</th>
                            <th>Challan No.</th>
                            <th>Type</th>
                            <th>Total Qty</th>
                            <th>Item Amount (Excl. GST)</th>
                            <th>GST</th>
                            <th>Total Amount (Incl. GST)</th>
                            <th>Project</th>
                            {/* <th>Project No</th> */}
                            {/* <th>Item Count</th> */}

                            <th className="text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {challanData?.map((elem, i) => (
                            <tr key={elem?._id}>
                              <td>{(currentPage - 1) * limit + i + 1}</td>
                              <td>
                                {elem?.date
                                  ? moment(elem.date).format("YYYY-MM-DD")
                                  : "-"}
                              </td>
                              <td>{elem?.challan_no || "-"}</td>
                              <td>
                                {elem?.challan_type || 'Non-Returnable'}
                              </td>
                              <td>{elem?.total_qty || "-"}</td>
                              <td>{elem?.challan_type === 'Returnable' ? 'N/A' : (elem?.total_amount?.toFixed(2) || "-")}</td>
                              <td>{elem?.challan_type === 'Returnable' ? 'N/A' : (elem?.total_amount ? (elem.total_amount * 0.18).toFixed(2) : "-")}</td>
                              <td>{elem?.challan_type === 'Returnable' ? 'N/A' : (elem?.total_amount ? Math.round(elem.total_amount + (elem.total_amount * 0.18)).toFixed(2) : "-")}</td>
                              <td>
                                {`${elem.projectDetails?.name} ${elem.projectDetails?.project_no
                                  ? `(${elem.projectDetails?.project_no})`
                                  : ""
                                  }` || "-"}
                              </td>
                              {/* <td>{elem?.manual_project_no || "-"}</td> */}
                              {/* <td>{elem?.item_count || "-"}</td> */}
                              <td className="text-end">
                                <div className="dropdown dropdown-action">
                                  <a
                                    href="#"
                                    className="action-icon dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="fa fa-ellipsis-v"></i>
                                  </a>
                                  <div className="dropdown-menu dropdown-menu-end">
                                    <button
                                      type="button"
                                      className="dropdown-item"
                                      onClick={() =>
                                        navigate(
                                          `/main-store/user/view-delivery-challan`,
                                          { state: elem },
                                        )
                                      }
                                    >
                                      <i className="fa-solid fa-eye m-r-5"></i>{" "}
                                      View
                                    </button>
                                    <button
                                      type="button"
                                      className="dropdown-item"
                                      onClick={() =>
                                        navigate(
                                          `/main-store/user/manage-delivery-challan`,
                                          { state: elem },
                                        )
                                      }
                                    >
                                      <i className="fa-solid fa-pen-to-square m-r-5"></i>{" "}
                                      Edit
                                    </button>
                                    <button
                                      type="button"
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleDelete(elem?._id, elem.challan_no)
                                      }
                                    >
                                      <i className="fa fa-trash-alt m-r-5"></i>{" "}
                                      Delete
                                    </button>
                                    <button
                                      type="button"
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleDownloadChallan(elem?._id)
                                      }
                                    >
                                      <i className="fa fa-download m-r-5"></i>{" "}
                                      Download Challan
                                    </button>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}
                          {challanData?.length === 0 ? (
                            <tr>
                              <td colSpan="999">
                                <div className="no-table-data">
                                  No Data Found!
                                </div>
                              </td>
                            </tr>
                          ) : null}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <>
                      <Loader />
                    </>
                  )}

                  <div className="row align-center mt-3 mb-2">
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                      <div
                        className="dataTables_info"
                        id="DataTables_Table_0_info"
                        role="status"
                        aria-live="polite"
                      >
                        Showing {Math.min(limit, totalItems)} from {totalItems}{" "}
                        data
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                      <div
                        className="dataTables_paginate paging_simple_numbers"
                        id="DataTables_Table_0_paginate"
                      >
                        <Pagination
                          total={totalItems}
                          itemsPerPage={limit}
                          currentPage={currentPage}
                          onPageChange={(page) => setCurrentPage(page)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default DeliveryChallanList;
